
  <div class="modal-header">
    <h4 class="modal-title">
      ONLINE-BOOK SHIPMENT - SEARCH
    </h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="bsModalRef.hide()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body grid-container">
    <form id="ratesSroMaintenanceSearchGroup" role="form" [formGroup]="appChargeCodeForm">
      <div class="grid-row">
        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
          <label class="usa-label">Charge Code:</label>
          <input type="text" id="totalPieces" class="usa-input maxw-full" formControlName="chargeCode" maxlength="225" />
        </div>
        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
          <label class="usa-label">Comments:</label>
          <textarea type="text" id="totalPieces1" class="usa-textarea maxw-full" formControlName="comments" maxlength="255"></textarea>
        </div>
      </div>
    </form>
    <div class="grid-row">
      <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
        <ag-grid-angular
          class="ag-theme-alpine padding-top-4"
          [gridOptions]="shipmentPreferredAddressesGridOptions"
          [rowData]="appChargeCodeList"
          [components]="frameworkComponents">
        </ag-grid-angular>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <div class="btn-group">
      <button type="button" class="usa-button" (click)="addToList()">
        Add to List
      </button>
      <button type="button" class="usa-button usa-button--secondary" (click)="bsModalRef.hide()">
        Close
      </button>
    </div>
  </div>
